function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 11.5C13.4918 11.5 14.9226 10.9074 15.9775 9.85248C17.0324 8.79758 17.625 7.36684 17.625 5.875C17.625 4.38316 17.0324 2.95242 15.9775 1.89752C14.9226 0.842632 13.4918 0.25 12 0.25C10.5082 0.25 9.07742 0.842632 8.02252 1.89752C6.96763 2.95242 6.375 4.38316 6.375 5.875C6.375 7.36684 6.96763 8.79758 8.02252 9.85248C9.07742 10.9074 10.5082 11.5 12 11.5ZM23.25 20.875C23.25 22.75 21.375 22.75 21.375 22.75H2.625C2.625 22.75 0.75 22.75 0.75 20.875C0.75 19 2.625 13.375 12 13.375C21.375 13.375 23.25 19 23.25 20.875Z",
  fill: "#23335B"
});

var SvgPersonGrey = function SvgPersonGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPersonGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/personGrey.8927aeb2.svg";
export { ForwardRef as ReactComponent };